import axiosHttp from "./interceptor";

export const updateAccountDetails = async (email, phoneNumber) => {
	try {
		const response = await axiosHttp.put(
			`api/Accounts/UpdateUserPhone?userName=${email}&phoneNumber=${phoneNumber}`
		);
		return response.data;
	} catch (error) {
		console.error(error.message);
	}
};
